import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../button'
import './style.css'

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const buttons = [
    { textBody: 'Login', route: '/selecione-tipo?action=login' },
    { textBody: 'Criar Conta', route: '/criar-conta-paciente' }
  ]

  const menuItems = [
    { label: 'Início', path: '/' },
    { label: 'Institucional', path: '/institucional' },
    { label: 'Contato', path: '/contato' }
  ]

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

    const closeMenu = () => {
        setIsMenuOpen(false)
    }

    const renderMenuItems = () => {
        return menuItems.map((item) => (
            <li key={item.path} className="menu-item">
                <Link to={item.path} onClick={closeMenu}>{item.label}</Link>
            </li>
        ))
    }

    const renderButtons = () => {
        return buttons.map((button) => (
            <Button 
                key={button.route} 
                textBody={button.textBody} 
                route={button.route} 
                className="header-button"
            />
        ))
    }

    const renderMobileButtons = () => {
        return buttons.map((button) => (
            <li key={button.route} className="mobile-menu-item">
                <Link to={button.route} onClick={closeMenu}>
                    {button.textBody}
                </Link>
            </li>
        ))
    }

    return (
        <header className="main-header">
            <div className="header-wrapper">
                <h1 className="brand-title">
                    <Link to="/" onClick={closeMenu}>VidaPlus</Link>
                </h1>

                {/* Desktop Navigation */}
                <nav className="navigation desktop-nav">
                    <ul className="menu-list">
                        {renderMenuItems()}
                    </ul>
                </nav>

                {/* Desktop Buttons */}
                <div className="button-group desktop-buttons">
                    {renderButtons()}
                </div>

                {/* Hamburger Button */}
                <button 
                    className={`hamburger ${isMenuOpen ? 'active' : ''}`}
                    onClick={toggleMenu}
                    aria-label="Menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                {/* Mobile Menu */}
                <nav className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
                    <ul className="mobile-menu-list">
                        {renderMenuItems()}
                        {renderMobileButtons()}
                    </ul>
                </nav>
            </div>

            {/* Overlay */}
            {isMenuOpen && <div className="overlay" onClick={closeMenu}></div>}
        </header>
    )
}